<script>
import { useStore } from "vuex";
import { useState, useLog } from "../../../../../../../services/hooks";
import { findByNameRequest } from "../../../../../../../api/notaries";
import NameComponent from "./NameComponent.vue";
import SelectedNotaryComponent from "./SelectedNotaryComponent.vue";

export default {
  name: "SearchNotaryComponent",
  components: {
    NameComponent,
    SelectedNotaryComponent
  },
  props: {
    notary: {
      type: Object,
      required: true
    },
    isDataServiceUnavailable: {
      type: Boolean,
      required: true
    },
    notarialCaseNumber: {
      type: String
    },
    setLocalNotaryId: {
      type: Function,
      required: true
    },
    setNotarialCaseNumber: {
      type: Function,
      required: true
    }
  },
  setup(props) {

    const [fieldName, setFieldName] = useState('');
    const [notaries, setNotaries] = useState([]);
    const [selectedNotaryItem, setSelectedNotaryItem] = useState(null);
    const setLocalNotaryId = props.setLocalNotaryId;
    const { recordLog } = useLog();

    const handleNotarySearch = () => {
      setTimeout(function () {
        findByNameRequest({
          name: fieldName.value
        }).then(response => {
          const data = response.data.data;
          if(data.length) {
            setNotaries(data);
            recordLog('Найден нотариус');
          } else {
            handleClearForm();
            recordLog('Нотариус не найден');
          }
        }).catch(err => console.log(err));
      }, 0);
    };

    const handleClearForm = () => {
      setNotaries([]);
      setFieldName('');
    };

    const handleSelectNotary = (e, notaryItem) => {
      e.preventDefault();
      setSelectedNotaryItem(notaryItem);
      setLocalNotaryId(notaryItem.id);
      handleClearForm();
      recordLog('Ручной выбор нотариуса (' + notaryItem.name + ')');
    };

    return {
      fieldName,
      notaries,
      handleClearForm,
      handleNotarySearch,
      handleSelectNotary,
      selectedNotaryItem
    }
  }
}
</script>

<template>
  <div class="notary-custom">
    <div class="inner">
      <div>
        <p v-if="isDataServiceUnavailable" class="red">
          Не смогли определить нотариуса, т.к. федеральный реестр нотариальных дел в данный момент не отвечает - вы можете указать номер дела и нотариуса вручную или попробовать еще раз позже.
        </p>
        <p v-else class="blue">По указанным ФИО/дате смерти дело о наследстве не найдено.</p>
        <p>Проверьте введенные данные. Если нужно - скорректируйте и мы проверим еще раз. Если вы уверены во введенных данных, то можете указать ФИО вручную, либо, если вы еще не выбрали нотариуса, то можете пропустить этот пункт (опция отправки результатов оценки нотариусу в таком случае будет недоступна):</p>
      </div>
      <name-component
        v-model:value="fieldName"
        :notaries="notaries"
        :select-notary-handler="handleSelectNotary"
        :search-submit-handler="handleNotarySearch"
      />
      <selected-notary-component
        v-if="selectedNotaryItem"
        :current-notary-region="selectedNotaryItem.name"
        :current-notary-name="selectedNotaryItem.region.name"
        :notarial-case-number="notarialCaseNumber"
        :set-notarial-case-number="setNotarialCaseNumber"
      />
    </div>
    <div v-if="notaries.length" class="overlay" @click="handleClearForm"></div>
  </div>
</template>

<style scoped>

.inner {
  position: relative;
  z-index: 2;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.notary-custom p {
  margin-bottom: 5px;
}

.blue {
  color: #3294ca;
}

</style>
